import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { getTemplatesRoute } from 'FormsUI/lib/RouteGenerators';
import { createNewEditorForm } from 'FormsUI/actions/formCreation/newEditor/createNewEditorForm';
import { trackDashboardInteraction } from 'FormsUI/utils/TrackingUtils';
import { getSelectedType } from 'FormsUI/selectors/FormCreation';
export const useCreateNewEditorForm = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const selectedType = useSelector(getSelectedType);
  const onCreateFromScratchClick = useCallback(() => {
    trackDashboardInteraction('create-new-editor-form-from-scratch-clicked');
    return void dispatch(createNewEditorForm());
  }, [dispatch]);
  const onCreateFromTemplateClick = useCallback(() => {
    trackDashboardInteraction('create-new-editor-form-from-template-clicked');
    history.push(getTemplatesRoute(selectedType));
  }, [history, selectedType]);
  return {
    onCreateFromScratchClick,
    onCreateFromTemplateClick
  };
};